export default [
  { id: 'language_ank', name: 'ANK' },
  { id: 'language_japanese', name: 'JAPANESE' },
  { id: 'language_chinese', name: 'CHINESE' },
  { id: 'language_taiwan', name: 'TAIWAN' },
  { id: 'language_korean', name: 'KOREAN' },
  { id: 'language_thai', name: 'THAI' },
  { id: 'language_southasia', name: 'SOUTHASIA' },
];
